{
  "instances": {
    "caches": {
      "label": "Кэши",
      "cache_manager": "Кэш-менеджер",
      "loading": "Загрузка кэшей...",
      "name": "Имя",
      "no_caches_found": "Кэши не найдены."
    }
  }
}
